import type { SiteInfo } from '../seo/jsonld.js';

/** Clave global donde viaja el estado del server al cliente. */
export const SSR_DATA_KEY = '__SSR_DATA__';

export interface SsrPayload {
  /** Key de la ruta que resolvió el loader. */
  routeKey: string;
  data: unknown;
  /**
   * Identidad del sitio tal como la resolvió el server (nombre + origen del request).
   *
   * Viaja al cliente porque hay cosas que se arman con el **origen** y se dibujan en el
   * navegador: los links de compartir, el canonical al navegar. El cliente no puede
   * deducirlo en el camino de render (`window` rompe el SSR) y `Tenant.domain` no sirve:
   * es opcional y no conoce el esquema ni el túnel.
   */
  site: SiteInfo;
}

/**
 * Serializa el resultado del loader para inyectarlo en el HTML.
 *
 * `<` se escapa a `<`: sin eso, un `</script>` dentro de los datos (por ejemplo en el
 * cuerpo de una nota) cerraría el tag antes de tiempo → XSS.
 */
export function serializeSsrData(payload: SsrPayload): string {
  const json = JSON.stringify(payload).replace(/</g, '\\u003c');
  return `<script>window.${SSR_DATA_KEY}=${json}</script>`;
}

/** Lee el payload inyectado por el server (o `null` si la página se cargó client-side). */
export function readSsrData(): SsrPayload | null {
  if (typeof window === 'undefined') return null;
  const raw = (window as unknown as Record<string, unknown>)[SSR_DATA_KEY];
  return (raw as SsrPayload | undefined) ?? null;
}
